<template>
  <section class="quote-info">
    <div class="box">
      <table class="table mg-b-10">
        <tr class="tr">
          <td>Insured Period</td>
          <td
            v-copy="formData.insurance_period"
            :class="{'green-tip':handleCompare('insurance_period')}">{{ formData.insurance_period}}</td>
        </tr>
        <tr class="tr">
          <td>Expected Insured Period</td>
          <td
            v-copy="formData.period_date"
            :class="{'green-tip':handleCompare('period_date')}">
            {{ formData.period_date }}
            <span
              v-if="formData.is_eff_dt_delay && formData.pcy_stts != 425"
              class="asap">(ASAP)</span>
          </td>
        </tr>
        <tr class="tr">
          <td>Total Price</td>
          <td
            v-if="showAmount"
            v-copy="amount"
            :class="{'green-tip':isChange}">{{ showAmount | formatMoney(2, true) }}</td>
        </tr>
        <tr
          v-if="!isEndorse"
          class="tr">
          <td>Policy Number </td>
          <td  :class="{'green-tip':handleCompare('pcy_no')}">{{ formData.pcy_no  }}</td>
        </tr>
        <tr
          v-else
          class="tr">
          <td>Endorsement Number </td>
          <td :class="{'green-tip':handleCompare('endorser_no')}">{{ formData.endorser_no  }}</td>
        </tr>
        <tr class="tr">
          <td>Policy Reference Code </td>
          <td :class="{'green-tip':handleCompare('order_sn')}">{{ formData.order_sn }}</td>
        </tr>
        <tr class="tr">
          <td>Referrer</td>
          <td
            v-if="referrer"
          >
            <referrer-info :referrer="referrer"></referrer-info>
          </td>
        </tr>
        <tr
          v-if="formData.discount_str&&isFina"
          class="tr">
          <td>Referrer Discount</td>
          <td>{{formData.discount_str}}</td>
        </tr>
        <tr class="tr">
          <td>Type of Building</td>
          <td
            v-copy="getAllOptionName26('bldg_types', formData.bldg_typ)"
            :class="{'green-tip':handleCompare('bldg_typ')}">{{ getAllOptionName26('bldg_types', formData.bldg_typ) }}</td>
        </tr>
        <tr class="tr">
          <td>Gross Floor Area</td>
          <td
            v-copy="formData.floor_area"
            :class="{'green-tip':handleCompare('floor_area')}">{{  formData.floor_area}}</td>
        </tr>
        <tr class="tr">
          <td>Sum Insured of Building Structure</td>
          <td
            v-copy="bsc_sum_insured"
            :class="{'green-tip':handleCompare('bsc_sum_insured')}">{{  formData.bsc_sum_insured | formatMoney(2, true) }}</td>
        </tr>
        <tr class="tr">
          <td>Do you need us to post a copy of the policy document to the Mortgagee?</td>
          <td
            v-copy="getOptionName('yesNoOptions', formData.post_ind)"
            :class="{'green-tip':handleCompare('post_ind')}">{{ getOptionName('yesNoOptions', formData.post_ind) }}</td>
        </tr>
        <tr
          v-if="formData.post_ind"
          class="tr">
          <td>Name of Mortgagee</td>
          <td
            v-copy="`${getAllOptionName29('mortgagor',formData.post_nm_id)} ${isOther?formData.post_nm_other:''}`"
            :class="{'green-tip':handleCompare('post_nm_id')}">{{getAllOptionName29('mortgagor',formData.post_nm_id)}} {{isOther?formData.post_nm_other:''}}</td>
        </tr>
        <tr
          v-if="formData.post_ind"
          class="tr">
          <td>Address of Mortgagee</td>
          <td
            v-copy="formData.post_addr"
            :class="{'green-tip':handleCompare('post_addr')}">{{  formData.post_addr}}</td>
        </tr>
        <tr class="tr">
          <td>Property Age </td>
          <td
            v-copy="getAllOptionName29('prop_age', formData.prop_age)"
            :class="{'green-tip':handleCompare('prop_age')}">{{ getAllOptionName29('prop_age', formData.prop_age) }}</td>
        </tr>
        <tr class="tr">
          <td>Occupancy</td>
          <td
            v-copy="getAllOptionName29('prop_insured', formData.prop_insured)"
            :class="{'green-tip':handleCompare('prop_insured')}">{{ getAllOptionName29('prop_insured', formData.prop_insured) }}</td>
        </tr>
        <div
          v-if="formData.has_roof!=-1"
          class="tr">
          <td>Does the flat have a roof/garden/balcony/workspace?</td>
          <td
            v-copy="getAllOptionName29('has_roof', formData.has_roof)"
            :class="{'green-tip':handleCompare('has_roof')}">{{ getAllOptionName29('has_roof', formData.has_roof) }}</td>
        </div>
        <tr class="tr">
          <td>Is your Location of Risk same as Correspondence Address?</td>
          <td
            v-copy="getOptionName('yesNoOptions', formData.is_same_as_corr_addr)"
            :class="{'green-tip':handleCompare('is_same_as_corr_addr')}">{{ getOptionName('yesNoOptions', formData.is_same_as_corr_addr) }}</td>
        </tr>
        <tr
          v-if="option_benefits.length>0"
          class="tr">
          <td>Optional Benefits</td>
          <td>
            <span
              v-for="(item,index) in option_benefits"
              :key="'extra'+index"
              v-copy="item.item">{{item.item}}<br></span>
          </td>
        </tr>
      </table>
    </div>
    <div class="box">
      <div
        v-for="(excessItem, excessIndex) in coverageList.items"
        :key="'coverage' + excessIndex">
        <table
          v-if="excessItem.sub_items.length>0"
          class="table">
          <h3 :class="{'table-title':excessIndex>0}">{{ excessItem.sub_title? excessItem.sub_title: coverageList.title }}</h3>
          <tr
            v-if="excessIndex==0"
            class="tr th">
            <th>Item</th>
            <th>Information</th>
          </tr>
          <tr
            v-for="(subItem, subIndex) in excessItem.sub_items"
            :key="'coverage-' + excessIndex + subIndex"
            class="tr">
            <td>{{ subItem.item }}</td>
            <td v-copy="subItem.premium">{{ subItem.premium }}</td>
          </tr>
          <tr class="tr">
            <td>Coverage Remark</td>
            <td
              v-copy="changeLineData(formData.cvr_remark)"
              :class="{'green-tip':handleCompare('quote_remark')}"
              v-html="changeLineData(formData.cvr_remark)"></td>
          </tr>
        </table>
      </div>
    </div>
    <div
      v-if="excessList.length>0"
      class="box">
      <h3>Excess</h3>
      <table class="table">
        <tr class="tr th">
          <th>Item</th>
          <th>Amount</th>
        </tr>
        <tr
          v-for="(inItem, index) in excessList"
          :key="index"
          class="sub">
          <td>
            <span  class="sub-title">{{ inItem.sub_title }}</span>
            <template
              v-for="(val,i) in inItem.sub_items">
              <p
                :key="i"
                v-copy="val.item"
                class="fw-400">{{ val.item }}</p>
            </template>
          </td>
        </tr>
        <tr class="tr">
          <td>Excess Remark</td>
          <td
            v-copy="changeLineData(formData.quote_remark)"
            :class="{'green-tip':handleCompare('quote_remark')}"
            v-html="changeLineData(formData.quote_remark)"></td>
        </tr>
      </table>
    </div>
    <div class="box">
      <h3>Location of Risk</h3>
      <table class="table">
        <tr class="tr">
          <td>Room</td>
          <td
            v-copy="isSameAddress? formData.addr_room :formData.insured_addr_room"
            :class="{'green-tip':!isSameAddress&&handleCompare('insured_addr_room')}">{{ isSameAddress? formData.addr_room :formData.insured_addr_room }}</td>
        </tr>
        <tr class="tr">
          <td>Floor</td>
          <td
            v-copy="isSameAddress? formData.addr_floor :formData.insured_addr_floor"
            :class="{'green-tip':!isSameAddress&&handleCompare('insured_addr_floor')}">{{ isSameAddress? formData.addr_floor :formData.insured_addr_floor }}</td>
        </tr>
        <tr class="tr">
          <td>Block</td>
          <td
            v-copy="isSameAddress? formData.addr_block :formData.insured_addr_block"
            :class="{'green-tip':!isSameAddress&&handleCompare('insured_addr_block')}">{{ isSameAddress? formData.addr_block :formData.insured_addr_block }}</td>
        </tr>
        <tr class="tr">
          <td>Building / Estate</td>
          <td
            v-copy="isSameAddress? formData.addr_building :formData.insured_addr_building"
            :class="{'green-tip':!isSameAddress&&handleCompare('insured_addr_building')}">{{ isSameAddress? formData.addr_building :formData.insured_addr_building }}</td>
        </tr>
        <tr class="tr">
          <td>Street</td>
          <td
            v-copy="isSameAddress? formData.addr_street :formData.insured_addr_street"
            :class="{'green-tip':!isSameAddress&&handleCompare('insured_addr_street')}">{{ isSameAddress? formData.addr_street :formData.insured_addr_street }}</td>
        </tr>
        <tr class="tr">
          <td>District</td>
          <td
            v-copy="getAreaName('district', isSameAddress? formData.addr_district :formData.insured_addr_district)"
            :class="{'green-tip':!isSameAddress&&handleCompare('insured_addr_district')}">{{ getAreaName('district', isSameAddress? formData.addr_district :formData.insured_addr_district) }}</td>
        </tr>
        <tr class="tr">
          <td>Area</td>
          <td
            v-copy="getAreaName('area', isSameAddress? formData.addr_area :formData.insured_addr_area)"
            :class="{'green-tip':!isSameAddress&&handleCompare('insured_addr_area')}">{{ getAreaName('area', isSameAddress? formData.addr_area :formData.insured_addr_area) }}</td>
        </tr>
        <tr class="tr">
          <td>Country / Region</td>
          <td
            v-copy="getAreaName('region', isSameAddress? formData.addr_region :formData.insured_addr_region)"
            :class="{'green-tip':!isSameAddress&&handleCompare('insured_addr_region')}">{{ getAreaName('region', isSameAddress? formData.addr_region :formData.insured_addr_region) }}</td>
        </tr>
      </table>
    </div>

    <div class="box">
      <h2>Policyholder Detail</h2>
      <table class="table">
        <template v-if="formData.cust_typ == 1">
          <tr class="tr">
            <td>Title</td>
            <td
              v-copy="getOptionName('titleOptions', formData.isrd_title)"
              :class="{'green-tip':handleCompare('isrd_title')}">{{ getOptionName('titleOptions', formData.isrd_title) }}</td>
          </tr>
          <tr class="tr">
            <td>Last Name</td>
            <td
              v-copy="formData.isrd_lst_nm "
              :class="{'green-tip':handleCompare('isrd_lst_nm')}">{{ formData.isrd_lst_nm }}</td>
          </tr>
          <tr class="tr">
            <td>First Name</td>
            <td
              v-copy="formData.isrd_fst_nm"
              :class="{'green-tip':handleCompare('isrd_fst_nm')}">{{ formData.isrd_fst_nm }}</td>
          </tr>
          <tr class="tr">
            <td>Date of Birth</td>
            <td
              v-copy="formData.isrd_dob_date"
              :class="{'green-tip':handleCompare('isrd_dob_date')}">{{ formData.isrd_dob_date }}</td>
          </tr>
          <tr class="tr">
            <td>HKID</td>
            <td
              v-copy="formData.id_no"
              :class="{'green-tip':handleCompare('id_no')}">{{ formData.id_no }}</td>
          </tr>
          <tr class="tr">
            <td>Mobile Number</td>
            <td
              v-copy="formData.mobile_no"
              :class="{'green-tip':handleCompare('mobile_no')}">{{ formData.mobile_no }}</td>
          </tr>
          <tr class="tr">
            <td>Email</td>
            <td
              v-copy="formData.email"
              :class="{'green-tip':handleCompare('email')}">
              {{ formData.email }}
              <email-tooltip :email="formData.email"></email-tooltip>
            </td>
          </tr>
          <tr class="tr">
            <td>Occupation</td>
            <td
              v-copy="formData.occ"
              :class="{'green-tip':handleCompare('occ }}')}">{{ formData.occ }}</td>
          </tr>
          <template v-if="isShowOwners">
            <tr class="tr">
              <td>Are there joint owners?</td>
              <td
                v-copy="getOptionName('yesNoOptions',formData.joint_owner_ind)"
                :class="{'green-tip':handleCompare('joint_owner_ind }}')}">{{ getOptionName('yesNoOptions',formData.joint_owner_ind) }}</td>
            </tr>
          </template>
        </template>
        <template v-else>
          <tr class="tr">
            <td>Company Name</td>
            <td
              v-copy="formData.isrd_com_nm"
              :class="{'green-tip':handleCompare('isrd_com_nm')}">{{ formData.isrd_com_nm }}</td>
          </tr>
          <tr class="tr">
            <td>Business Registration Number</td>
            <td
              v-copy="formData.id_no"
              :class="{'green-tip':handleCompare('id_no')}">{{ formData.id_no }}</td>
          </tr>
          <!--          <div class="tr">-->
          <!--            <span>CI Number</span>-->
          <!--            <span>{{ formData.ci_no }}</span>-->
          <!--          </div>-->
          <tr class="tr">
            <td>Company Phone No.</td>
            <td
              v-copy="formData.phone_no"
              :class="{'green-tip':handleCompare('phone_no')}">{{ formData.phone_no }}</td>
          </tr>
          <tr class="tr">
            <td>Company Email</td>
            <td
              v-copy="formData.email"
              :class="{'green-tip':handleCompare('email')}">
              {{ formData.email }}
              <email-tooltip :email="formData.email"></email-tooltip>
            </td>
          </tr>
          <tr class="tr">
            <td>Nature of Business</td>
            <td
              v-copy="getAllOptionName29('industry', formData.bsns_nature_id)"
              :class="{'green-tip':handleCompare('bsns_nature_id')}">{{ getAllOptionName29('industry', formData.bsns_nature_id) }}</td>
          </tr>
          <template v-if="isShowOwners">
            <tr class="tr">
              <td>Are there joint owners?</td>
              <td
                v-copy="getOptionName('yesNoOptions',formData.joint_owner_ind)"
                :class="{'green-tip':handleCompare('joint_owner_ind }}')}">{{ getOptionName('yesNoOptions',formData.joint_owner_ind) }}</td>
            </tr>
          </template>
          <span class="title">Contact Person</span>
          <tr class="tr">
            <td>Name</td>
            <td
              v-copy="formData.contact_nm"
              :class="{'green-tip':handleCompare('contact_nm')}">{{ formData.contact_nm }}</td>
          </tr>
          <tr class="tr">
            <td>Occupation</td>
            <!--            <span-->
            <!--              v-copy="getAllOptionName24('occupation', formData.contact_occ_id)"-->
            <!--              :class="{'green-tip':handleCompare('contact_occ_id')}">{{ getAllOptionName24('occupation', formData.contact_occ_id) }}</span>      -->
            <td
              v-copy="formData.bsns_nature"
              :class="{'green-tip':handleCompare('contact_occ_id')}">{{ formData.bsns_nature}}</td>
          </tr>
          <tr class="tr">
            <td>Phone No.</td>
            <td
              v-copy="formData.contact_phone"
              :class="{'green-tip':handleCompare('contact_phone')}">{{ formData.contact_phone }}</td>
          </tr>
          <tr class="tr">
            <td>Email</td>
            <td
              v-copy="formData.contact_email"
              :class="{'green-tip':handleCompare('contact_email')}">
              {{ formData.contact_email }}
              <email-tooltip :email="formData.email"></email-tooltip>
            </td>
          </tr>
        </template>
      </table>
    </div>
    <template  v-if="formData.joint_owner_ind==1">
      <div class="box">
        <h3>Joint Policyholder Details</h3>
        <table class="table">

          <tr
            class="tr">
            <td>Joint Policyholder - Full Name</td>
            <td
              v-copy="formData.joint_owner_nm"
            >{{formData.joint_owner_nm}}</td>
          </tr>
          <tr
            class="tr">
            <td>Date of Birth</td>
            <td
              v-copy="formData.joint_owner_dob"
            >{{showHKDate(formData.joint_owner_dob)}}</td>
          </tr>
          <tr
            class="tr">
            <td>Joint Policyholder - {{getOptionName('personalIdTypOptions',formData.joint_owner_id_type)}}</td>
            <td
              v-copy="formData.joint_owner_id_no"
            >{{formData.joint_owner_id_no}}</td>
          </tr>
        </table>
      </div>
    </template>
    <div class="box">
      <h3>Correspondence Address</h3>
      <table class="table">
        <tr class="tr">
          <td>Room</td>
          <td
            v-copy="formData.addr_room"
            :class="{'green-tip':handleCompare('addr_room')}">{{ formData.addr_room }}</td>
        </tr>
        <tr class="tr">
          <td>Floor</td>
          <td
            v-copy="formData.addr_floor"
            :class="{'green-tip':handleCompare('addr_floor')}">{{ formData.addr_floor }}</td>
        </tr>
        <tr class="tr">
          <td>Block</td>
          <td
            v-copy="formData.addr_block"
            :class="{'green-tip':handleCompare('addr_block')}">{{ formData.addr_block }}</td>
        </tr>
        <tr class="tr">
          <td>Building / Estate</td>
          <td
            v-copy="formData.addr_building"
            :class="{'green-tip':handleCompare('addr_building')}">{{ formData.addr_building }}</td>
        </tr>
        <tr class="tr">
          <td>Street</td>
          <td
            v-copy="formData.addr_street"
            :class="{'green-tip':handleCompare('addr_street')}">{{ formData.addr_street }}</td>
        </tr>
        <tr class="tr">
          <td>District</td>
          <td
            v-copy="getAreaName('district', formData.addr_district)"
            :class="{'green-tip':handleCompare('addr_district')}">{{ getAreaName('district', formData.addr_district) }}</td>
        </tr>
        <tr class="tr">
          <td>Area</td>
          <td
            v-copy="getAreaName('area', formData.addr_area)"
            :class="{'green-tip':handleCompare('addr_area')}">{{ getAreaName('area', formData.addr_area) }}</td>
        </tr>
        <tr class="tr">
          <td>Country / Region</td>
          <td
            v-copy="getAreaName('region', formData.addr_region)"
            :class="{'green-tip':handleCompare('addr_region')}">{{ getAreaName('region', formData.addr_region) }}</td>
        </tr>
      </table>
    </div>
    <div
      v-if="hasBenefitsTab"
      class="box">
      <h3>More Benefits Detail</h3>
      <template v-if="hasBenefitsEmployees">
        <h4>Domestic Helper Information</h4>
        <table
          v-for="(item, index) in formData.domestic_helper_info"
          :key="index"
          class="table">
          <tr class="tr th">
            <th>Field</th>
            <th>Domestic Helper {{ index+1 }}</th>
          </tr>
          <tr class="tr">
            <td>Name</td>
            <td
              v-copy="item.name"
              :class="{'green-tip':compareChange(index,'domestic_helper_info','name')}">{{ item.name }}</td>
          </tr>
          <tr class="tr">
            <td>Nationality</td>
            <td
              v-copy="getName(item.nationality)"
              :class="{'green-tip':compareChange(index,'domestic_helper_info','nationality')}">{{ getName(item.nationality) }}</td>
          </tr>
          <tr class="tr">
            <td>Date of Birth</td>
            <td
              v-copy="item.dob_date"
              :class="{'green-tip':compareChange(index,'domestic_helper_info','dob_date')}">{{ item.dob_date }}</td>
          </tr>
          <tr class="tr">
            <td>HKID / Passport Number</td>
            <td
              v-copy="item.id_no"
              :class="{'green-tip':compareChange(index,'domestic_helper_info','id_no')}">{{ item.id_no }}</td>
          </tr>
        </table>
      </template>
      <template v-if="hasBenefitsPets">
        <h4>Pet Information</h4>
        <table
          v-for="(item, index) in formData.pet_info"
          :key="index"
          class="table">
          <tr class="tr th">
            <th>Field</th>
            <th>Pet {{ index+1 }}</th>
          </tr>
          <tr class="tr">
            <td>Type of Pet</td>
            <td
              v-copy="getAllOptionName29('type_of_pet', item.type_of_pet)"
              :class="{'green-tip':compareChange(index,'pet_info','type_of_pet')}">{{ getAllOptionName29('type_of_pet', item.type_of_pet) }}</td>
          </tr>
          <tr class="tr">
            <td>Pet Name</td>
            <td
              v-copy="item.name"
              :class="{'green-tip':compareChange(index,'pet_info','name')}">{{ item.name }}</td>
          </tr>
          <tr class="tr">
            <td>Year of Birth</td>
            <td
              v-copy="item.dob"
              :class="{'green-tip':compareChange(index,'pet_info','dob')}">{{ item.dob }}</td>
          </tr>
          <tr class="tr">
            <td>Microchip No.</td>
            <td
              v-copy="item.microchip_no"
              :class="{'green-tip':compareChange(index,'pet_info','microchip_no')}">{{ item.microchip_no }}</td>
          </tr>
        </table>
      </template>
      <template v-if="hasBenefitsPhone">
        <h4>Accidental Damage to Mobile Phone</h4>
        <tr class="tr">
          <td>Mobile Phone Model Name 1</td>
          <td
            v-copy="formData.phone_mdl_1"
            :class="{'green-tip':handleCompare('phone_mdl_1')}">{{ formData.phone_mdl_1 }}</td>
        </tr>
        <tr class="tr">
          <td>Mobile Phone Model Name 2</td>
          <td
            v-copy="formData.phone_mdl_2"
            :class="{'green-tip':handleCompare('phone_mdl_2')}">{{ formData.phone_mdl_2 }}</td>
        </tr>
      </template>
    </div>
    <div class="box">
      <h3>Remark(s)</h3>
      <table class="table">
        <tr class="tr">
          <td>Remark</td>
          <td
            v-copy="formData.cs_manual_remark"
            :class="{'green-tip':handleCompare('cs_manual_remark')}"
            v-html="changeLineData(formData.cs_manual_remark)"></td>
        </tr>
      </table>
    </div>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import {mapState} from 'vuex'
import dayjs from 'dayjs'
import OMath from '@/utils/math'
import ReferrerInfo from '@/views/records/policy/components/info/referrer-info'

export default {
  name: 'HomefirePolicyInfo',
  components: {ReferrerInfo},
  mixins: [MixinOptions, MixinFormat],
  props: {
    formData: {
      type: Object,
      default: () => ({})
    },
    preFormData: {
      type: Object,
      default: () => ({})
    },
    showAmount: {
      type: [String,Number],
      default: ''
    },
    isChange: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    ...mapState('common', ['nationalityOptions']),
    isShowOwners(){
      let {prop_insured} = this.formData||{}
      return prop_insured!=3
    },
    isFina(){
      let {merchant_platform} = this.formData||{}
      return merchant_platform==2
    },
    isOther(){
      let {post_nm_id} = this.formData||{}
      let data ={}
      let {mortgagor=[] } = this.allOptions29||{}
      mortgagor.some(item => {
        if (item.id == post_nm_id) {
          data = item
          return true
        }
        return false
      })
      return data.is_other||''
    },
    amount(){
      return  OMath.formatMoney(this.showAmount, 2,true)
    },
    bsc_sum_insured(){
      let {bsc_sum_insured} = this.formData||{}
      return  OMath.formatMoney(bsc_sum_insured, 2,true)
    },
    referrer(){
      let {referrer} = this.formData||{}
      return referrer||{}
    },
    sidebarPremium() {
      let {quote_coverage_list={}} =this.formData||{}
      if(!quote_coverage_list) {
        return []
      }
      let { sidebar_premium=[]} =quote_coverage_list||{}
      if(sidebar_premium.length<=0)return  []
      return sidebar_premium
    },
    option_benefits(){
      let {quote_coverage_list={}} = this.formData||{}
      let {more_benefit={}} = quote_coverage_list||{}
      let {sub_items={}} = more_benefit||{}
      let arr =[]
      if(sub_items){
        arr = Object.entries(sub_items).map(item=>item[1])
      }
      return arr
    },
    isSameAddress() {
      return this.formData.is_same_as_corr_addr == 1
    },
    hasBenefitsTab() {
      const { benefits = [] } = this.formData
      if(!benefits || benefits.length < 1) {
        return false
      }
      let result = false
      benefits.some(item => {
        if([1, 4, 8].includes(item)) {
          result = true
          return true
        }
      })
      return result
    },
    hasBenefitsEmployees() {
      const { benefits = [] } = this.formData
      if(benefits && benefits.includes(1)) {
        return true
      }
      return false
    },
    hasBenefitsPets() {
      const { benefits = [] } = this.formData
      if(benefits && benefits.includes(4)) {
        return true
      }
      return false
    },
    hasBenefitsPhone() {
      const { benefits = [] } = this.formData
      if(benefits && benefits.includes(8)) {
        return true
      }
      return false
    },
    endDate(){
      let {pcy_cmnt_dt=''} = this.formData||{}
      return pcy_cmnt_dt?dayjs(pcy_cmnt_dt).add(1,'year').format('YYYY-MM-DD'):''
    },
    coverageList(){
      let {quote_coverage_list} = this.formData||{}
      let {coverage} = quote_coverage_list||{}
      // let {items} = coverage||{}
      // if(items){
      //   return items[0].sub_items
      // }
      return  coverage||{}
    },
    excessList(){
      let {quote_coverage_list} = this.formData||{}
      let {excess} = quote_coverage_list||{}
      let {items} = excess||{}
      return items || []
    },
    compareList(){
      let {type} = this.formData||{}
      let nowData = this.formData||{}
      let pre = this.preFormData||{}
      if(type!=50)return []
      let arr =  Object.keys(nowData).reduce((result,key)=>{
        if(nowData[key]!=pre[key]){
          result.push(key)
        }
        return result
      },[])
      return arr||[]
    },
    compareChange(){
      return (index,name,field)=>{
        let {type} = this.form||{}
        let pre = this.preFormData||{}
        let preData =pre[name]||{}
        let nowData =this.form[name]||{}
        if(type!=50)return  false
        if(preData.length<=0)return  false
        return nowData[index][name]!=preData[index][name]||false
      }
    },
    isEndorse(){
      return [30,40].includes(this.formData.type)
    },
  },
  mounted(){
    console.log(this.formData)
  },
  methods: {
    handleCompare(filed){
      let {type} = this.formData
      if(type!=50) return false
      return  this.compareList.includes(filed)?true:false
    },
    openFile(url) {
      if(url) {
        window.open(url, '_blank')
      }
    },
    getName(id){
      let data = this.nationalityOptions.filter(item=>{
        return item.id==id
      })
      return data.length>0?data[0].name:''
    }
  }
}
</script>
<style lang="scss" scoped>
.quote-info{
  .box {
    margin-bottom: 15px;
  }
  .title {
    padding: 15px 0;
  }
  h4 {
    padding-bottom: 10px;
    color: #616266;
  }
  .table-title {
    display: inline-block;
    padding-bottom: 2px;
    padding-left: 5px;
    font-size: 12px;
    font-weight: bold;
    color: #909399;
    line-height: 15px;
  }
  .sub{
    padding: 5px;
    width: 100%;
    border-bottom: 1px solid #dddfe7;
    font-size: 12px;
    color: #606266;
    .sub-title{
      font-weight: bold;
    }
  }
  .sub:nth-child(2n){
    background: rgba(0, 0, 0, 0.02);
  }
  .asap{
    font-weight: bold;
    color: black;
    margin-left: 5px;
  }
}
</style>
